export default "__VITE_ASSET__CqyfPn_5__"